// StepComplete.jsx
export function StepComplete({ session, onComplete }) {
  return (
    <div className="step-card center">
      <div className="complete-icon">🎉</div>
      <h1>You're verified!</h1>
      <p className="step-sub">
        Welcome, <strong>{session.profile?.firstName}</strong>. Your identity has been confirmed
        and your {session.role} account is ready.
      </p>

      <div className="summary-card">
        <div className="summary-row">
          <span className="summary-label">Role</span>
          <span className="summary-value capitalize">{session.role}</span>
        </div>
        <div className="summary-row">
          <span className="summary-label">Document</span>
          <span className="summary-value">
            {session.docType === "PASSPORT" ? "Passport" : "Driver's License / ID"}
          </span>
        </div>
        <div className="summary-row">
          <span className="summary-label">Face match</span>
          <span className="summary-value success">
            {session.faceResult?.similarity}% ✓
          </span>
        </div>
        <div className="summary-row">
          <span className="summary-label">Status</span>
          <span className="summary-value success">Verified</span>
        </div>
      </div>

      <button className="btn-primary" style={{ marginTop: "1.5rem" }}
        onClick={() => onComplete ? onComplete() : (window.location.href = "/")}>
        Go to Login →
      </button>
    </div>
  );
}

export default StepComplete;
